import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Switch, Table} from 'antd';
import TranslatedText from '../../TranslatedText';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {getMinersLoading, getMiningWorkers, getUpdatedTime, getWorkersCount} from '../../../redux/selectors/workers';
import {makeAction} from '../../../redux/actions/makeAction';
import {FETCH_MINING_WORKERS} from '../../../redux/actions/actionTypes';
import {useMediaQuery} from 'react-responsive';
import {hashrateToString} from '../../../services/hashrate';


const index = ({workersCount, updatedAt, isLoading, fetchMiningWorkers, miningWorkers}) => {
  const isMobile = useMediaQuery({query: '(max-width: 1200px)'});
  const {t} = useTranslation();
  const [filter, setFilter] = React.useState('all');
  const [advancedView, setAdvancedView] = React.useState(false);
  const columns = [
    {
      title: t('workers.table.name'),
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: t('workers.table.status'),
      dataIndex: 'active',
      key: 'active',
      render: active => active
        ? <span className="activity-wrapper">
            <span className="activity-icon activity-icon-active"/>
            <TranslatedText transKey="workers.filters.active"/>
        </span>
        : <span className="activity-wrapper">
            <span className="activity-icon activity-icon-inactive"/>
            <TranslatedText transKey="workers.filters.inactive"/>
          </span>,
    },
    {
      title: t('workers.table.rate'),
      dataIndex: 'rate',
      key: 'rate',
      sorter: (a, b) => a.rate - b.rate,
      sortDirections: ['ascend', 'descend'],
      render: text => hashrateToString(text),
    },
    ...(
      (isMobile && !advancedView)
        ? []
        : [
          {
            title: t('workers.table.lastip'),
            dataIndex: 'last_share_ip',
            key: 'last_share_ip',
            render: ip_addr => ip_addr === '0.0.0.0' ? '--' : ip_addr,
          },
          {
            title: t('workers.table.lasttime'),
            dataIndex: 'last_share_time',
            key: 'last_share_time',
            render: date => date === '1970-01-01T00:00:01Z' ? '--' : moment(date).format('L LT'),
          },
        ]
    ),
  ];

  return (
    <div className="container">
      <Card className="miners-table-card" bordered={false}>
        <div className="options-panel">
          <ul className="activity-filter">
            <li
              className={`all-count ${filter === 'all' ? 'active' : ''}`}
              onClick={() => filter !== 'all' && setFilter('all')}
            >
              <TranslatedText transKey="workers.filters.all"/>
              <span className="count-indicator">({workersCount.all})</span>
            </li>
            <li
              className={`active-count ${filter === 'active' ? 'active' : ''}`}
              onClick={() => filter !== 'active' && setFilter('active')}
            >
              <TranslatedText transKey="workers.filters.active"/>
              <span className="count-indicator">({workersCount.active})</span>
            </li>
            <li
              className={`inactive-count ${filter === 'inactive' ? 'active' : ''}`}
              onClick={() => filter !== 'inactive' && setFilter('inactive')}
            >
              <TranslatedText transKey="workers.filters.inactive"/>
              <span className="count-indicator">({workersCount.inactive})</span>
            </li>
          </ul>
          <div className="refresh-section">
          <span className="refresh-info">
            <span><TranslatedText transKey="workers.filters.lastupdate"/></span>
            <span>{moment(updatedAt).format('L LT')}</span>
          </span>
            <Button loading={isLoading} onClick={() => fetchMiningWorkers()} type="primary">
              <TranslatedText transKey="workers.filters.refresh"/>
            </Button>
          </div>
          {
            isMobile && <div className="advanced-section">
              <span className="switch-label"><TranslatedText transKey="workers.filters.advanced"/></span>
              <Switch checked={advancedView} onChange={setAdvancedView} />
            </div>
          }
        </div>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={
            filter === 'all'
              ? miningWorkers
              : filter === 'active'
              ? miningWorkers.filter(worker => worker.active)
              : miningWorkers.filter(worker => !worker.active)
          }
          size="small"
          rowKey="name"
          pagination={{
            pageSize: 12,
            hideOnSinglePage: true,
            itemRender: (page, type) => type === 'page' && <Button type="primary">{page}</Button>,
          }}
          className="dashboard"
          style={{'marginTop': '20px'}}
        />
      </Card>
    </div>
  );
};

index.propTypes = {
  miningWorkers: PropTypes.array.isRequired,
  workersCount: PropTypes.shape({
    all: PropTypes.number.isRequired,
    active: PropTypes.number.isRequired,
    inactive: PropTypes.number.isRequired,
  }).isRequired,
  updatedAt: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  fetchMiningWorkers: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  miningWorkers: getMiningWorkers(state),
  workersCount: getWorkersCount(state),
  updatedAt: getUpdatedTime(state),
  isLoading: getMinersLoading(state),
});

const mapDispatchToProps = {
  fetchMiningWorkers: makeAction(FETCH_MINING_WORKERS),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(index));



// WEBPACK FOOTER //
// /src/components/pages/workers/index.jsx